import { getWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';

/**
 * Resolve the workspace id from the current URL or throw.
 *
 * Lives in shared/ so every queryFn / mutationFn doesn't redefine it.
 * The error message is the public contract — change it once, not per file.
 *
 * **Throws during render.** The hooks that call this (`useCampaigns`,
 * `useCampaign`, `useCampaignActions`, `useCampaignTags`,
 * `useCampaignsForTag`, `useCampaignsCached`, `useDomains`, `useAction`, etc.)
 * are suspense reads designed for routes that always live under
 * `/workspaces/:workspaceId/...`. Mounting one outside a workspace
 * context will throw synchronously and bubble to the nearest error
 * boundary. For layouts/banners that mount before the URL settles,
 * use the corresponding `useXOptional` variant (e.g.
 * `useDomainsOptional`) which returns `data: undefined` instead of
 * throwing.
 */
export function requireWorkspaceId(): number {
  const id = getWorkspaceIdFromCurrentUrl();
  if (id == null || id <= 0) throw new Error('No workspace id in URL.');
  return id;
}
